import {ValidateUserPermissions} from 'src/common/utils/ValidatePermissions'

export enum ListObjectIdEnum {
  OBJECT_DETECTION = '1',
  LPR = '2',
  LINE_CROSSING = '3',
  FACIAL_RECOGNITION = '4',
  SCENE_CHANGE = '5',
  SPEED = '6',
  EPI = '7',
  HOODIE = '8',
  SHOPPING_CART = '9',
}

export enum ListObjectEnum {
  OBJECT_DETECTION = 'Detecção de Objetos',
  LPR = 'LPR',
  LINE_CROSSING = 'Cruzamento de Linha',
  FACIAL_RECOGNITION = 'Reconhecimento Facial',
  SCENE_CHANGE = 'Mudança de Cenário',
  SPEED = 'Velocidade',
  EPI = 'EPI',
  HOODIE = 'Capuz',
  SHOPPING_CART = 'Carrinho de Supermercado',
}

export function listTypesEvent() {
  let list: Array<string> = []
  const hasPermissionReadEvent = ValidateUserPermissions('events:read')
  const hasPermissionReadLineCrossing = ValidateUserPermissions('line-crossing:read')
  const hasPermissionReadFacial = ValidateUserPermissions('face:read')
  const hasPermissionReadLpr = ValidateUserPermissions('lpr:read')
  const hasPermissionReadSceneChange = ValidateUserPermissions('scene-change:read')

  if (hasPermissionReadEvent) list.push(ListObjectEnum.OBJECT_DETECTION)
  if (hasPermissionReadLineCrossing) list.push(ListObjectEnum.LINE_CROSSING)
  if (hasPermissionReadFacial) list.push(ListObjectEnum.FACIAL_RECOGNITION)
  if (hasPermissionReadLpr) list.push(ListObjectEnum.LPR)
  if (hasPermissionReadSceneChange) list.push(ListObjectEnum.SCENE_CHANGE)
  return list
}

export type FilterDate = {
  from?: string
  to?: string
}

export const objectTypeList = [
  {id: 1, name: 'person', code: 'B001', label: 'Pessoa', resourceId: 6},
  {id: 15, name: 'plate', code: 'B002', label: 'Placa', resourceId: 5},
  {id: 89, name: 'safety-clothes', code: 'B013', label: 'Equipamento de Segurança Incompleto', resourceId: 9},
  {id: 100, name: 'glass', code: 'B013', label: 'Equipamento de Segurança Incompleto', resourceId: 9},
  {id: 101, name: 'gloves', code: 'B013', label: 'Equipamento de Segurança Incompleto', resourceId: 9},
  {id: 92, name: 'body', code: 'B013', label: 'Corpo', resourceId: 7},
  {id: 96, name: 'face', code: 'B001', label: 'Facial', resourceId: 14},
  {id: 2, name: 'fork', code: 'B004', label: 'Garfo', resourceId: 7},
  {id: 3, name: 'knife', code: 'B004', label: 'Faca', resourceId: 7},
  {id: 4, name: 'cell phone', code: 'B005', label: 'Celular', resourceId: 7},
  {id: 5, name: 'scissors', code: 'B004', label: 'Tesoura', resourceId: 7},
  {id: 6, name: 'car', code: 'B002', label: 'Carro', resourceId: 7},
  {id: 7, name: 'bottle', code: 'B004', label: 'Garrafa', resourceId: 7},
  {id: 9, name: 'cup', code: 'B004', label: 'Copo', resourceId: 7},
  {id: 10, name: 'spoon', code: 'B004', label: 'Colher', resourceId: 7},
  {id: 11, name: 'book', code: 'B008', label: 'Livro', resourceId: 7},
  {id: 12, name: 'clock', code: 'B008', label: 'Relógio', resourceId: 7},
  {id: 13, name: 'mouse', code: 'B005', label: 'Mouse', resourceId: 7},
  {id: 14, name: 'motorcycle', code: 'B002', label: 'Moto', resourceId: 7},
  {id: 21, name: 'bicycle', code: 'B002', label: 'Bicicleta', resourceId: 7},
  {id: 23, name: 'airplane', code: 'B002', label: 'Avião', resourceId: 7},
  {id: 24, name: 'bus', code: 'B002', label: 'Ônibus', resourceId: 7},
  {id: 25, name: 'train', code: 'B002', label: 'Trem', resourceId: 7},
  {id: 26, name: 'truck', code: 'B002', label: 'Caminhão', resourceId: 7},
  {id: 27, name: 'boat', code: 'B002', label: 'Barco', resourceId: 7},
  {id: 28, name: 'traffic light', code: 'B007', label: 'Semáforo', resourceId: 7},
  {id: 29, name: 'fire hydrant', code: 'B007', label: 'Hidrante', resourceId: 7},
  {id: 30, name: 'stop sign', code: 'B007', label: 'Sinal de Parada', resourceId: 7},
  {id: 32, name: 'bench', code: 'B007', label: 'Banco de Sentar', resourceId: 7},
  {id: 33, name: 'bird', code: 'B006', label: 'Pássaro', resourceId: 7},
  {id: 34, name: 'cat', code: 'B006', label: 'Gato', resourceId: 7},
  {id: 35, name: 'dog', code: 'B006', label: 'Cão', resourceId: 7},
  {id: 36, name: 'horse', code: 'B006', label: 'Cavalo', resourceId: 7},
  {id: 37, name: 'sheep', code: 'B006', label: 'Ovelha', resourceId: 7},
  {id: 38, name: 'cow', code: 'B006', label: 'Vaca', resourceId: 7},
  {id: 43, name: 'backpack', code: 'B008', label: 'Mochila', resourceId: 7},
  {id: 44, name: 'umbrella', code: 'B008', label: 'Guarda-Chuva', resourceId: 7},
  {id: 45, name: 'handbag', code: 'B008', label: 'Bolsa', resourceId: 7},
  {id: 47, name: 'suitcase', code: 'B008', label: 'Mala de Viagem', resourceId: 7},
  {id: 53, name: 'baseball bat', code: 'B009', label: 'Taco de Beisebol', resourceId: 7},
  {id: 57, name: 'tennis racket', code: 'B009', label: 'Raquete de Tênis', resourceId: 7},
  {id: 69, name: 'chair', code: 'B004', label: 'Cadeira', resourceId: 7},
  {id: 71, name: 'potted plant', code: 'B004', label: 'Vaso de Planta', resourceId: 7},
  {id: 75, name: 'tv', code: 'B005', label: 'Televisão', resourceId: 7},
  {id: 76, name: 'laptop', code: 'B005', label: 'Computador Portátil', resourceId: 7},
  {id: 78, name: 'keyboard', code: 'B005', label: 'Teclado', resourceId: 7},
  {id: 84, name: 'vase', code: 'B004', label: 'Vaso', resourceId: 7},
  {id: 88, name: 'crowd', code: 'B011', label: 'Aglomeração', resourceId: 8},
  {id: 93, name: 'without-safety-clothes', code: 'B014', label: 'Equipamento de Segurança Incompleto', resourceId: 9},
  {id: 94, name: 'without-helmet', code: 'B014', label: 'Equipamento de Segurança Incompleto', resourceId: 9},
  {id: 90, name: 'helmet', code: 'B013', label: 'Equipamento de Segurança Incompleto', resourceId: 9},
  {id: 98, name: 'scene change', code: 'B015', label: 'Mudança de Cenário', resourceId: 16},
  {id: 99, name: 'object removal', code: 'B015', label: 'Remoção de objeto', resourceId: 21},
  {id: 6, name: 'cars crowd', code: 'B002', label: 'Carros', resourceId: 7},
  {id: 102, name: 'speed', code: 'B002', label: 'Velocidade', resourceId: 23},
  {id: 0, name: 'jacket', code: 'B014', label: 'Equipamento de Segurança Incompleto', resourceId: 9},
  {id: 104, name: 'demographic analysis', code: 'B015', label: 'Análise Demográfica', resourceId: 14},
  {id: 0, name: 'complete-epi', code: 'B013', label: 'Equipamento de Segurança Completo', resourceId: 9},
  {id: 103, name: 'epi', code: 'B014', label: 'EPI', resourceId: 9},
  {id: 105, name: 'vehicles', code: 'B002', label: 'Veículos', resourceId: 7},
  {id: 107, name: 'shopping-cart', label: 'Carrinho de Supermercado', code: 'B001', resourceId: 7},
  {id: 106, name: 'hoodie', label: 'Capuz', code: 'B001', resourceId: 7},
]
